import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import { useClickOutside, useScrollLock, useStores } from 'hooks';

import SideDrawModal from './SideDrawModal/index.jsx';
import CentralDrawModal from './CentralDrawModal';
import { MODAL_TYPE } from '../../../const/modalType';

const Modal = ({ children, isOpen = false, type }) => {
  const { handleScrollUnlock, handleScrollLock } = useScrollLock();
  const { modalStore } = useStores();
  const { close } = modalStore;

  useEffect(() => {
    if (isOpen) {
      handleScrollLock();
    }

    return () => {
      handleScrollUnlock();
    };
  }, [isOpen]);

  const contentRef = useClickOutside(() => {
    close();
  });

  const ModalComponent = () => {
    switch (type) {
      case MODAL_TYPE.MODAL_SIDE:
        return <SideDrawModal ref={contentRef}>{children}</SideDrawModal>;
      case MODAL_TYPE.MODAL_CENTER:
        return <CentralDrawModal ref={contentRef}>{children}</CentralDrawModal>;
    }
  };

  if (isOpen === false) return null;

  return ReactDOM.createPortal(<ModalComponent />, document.body);
};

export default Modal;
